'use client';

import { useEffect } from 'react';
import { pushDataLayer } from '@/lib/track-gtm';

interface Props {
  salespadId: string;
  slug: string;
  teamSlug: string;
}

/**
 * Fires `salescal.salespad_view` into window.dataLayer once on mount.
 * Renders nothing. Safe no-op when no GTM container is loaded.
 */
export function SalespadViewTracker({ salespadId, slug, teamSlug }: Props) {
  useEffect(() => {
    pushDataLayer('salescal.salespad_view', { salespadId, slug, teamSlug });
  }, [salespadId, slug, teamSlug]);
  return null;
}
